import React from 'react';

import { Tooltip } from '@schoolinks/ui-components';
import { noop } from 'lodash';
import { func, shape } from 'prop-types';

const Item = ({ item, renderFunction }) => (
  <Tooltip key={item.key} placement="bottom" title={item.tooltip}>
    <div>{renderFunction(item, noop)}</div>
  </Tooltip>
);

Item.propTypes = {
  item: shape({}).isRequired,
  renderFunction: func.isRequired,
};

export default Item;
